export default __webpack_public_path__ + "fonts/Grupo 134.svg";